import { render, staticRenderFns } from "./PageActivityTypeList.vue?vue&type=template&id=97289f92"
import script from "./PageActivityTypeList.vue?vue&type=script&lang=js"
export * from "./PageActivityTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports